export const handleCourseCategoryValue = (value: any) => {
    switch (value) {
        case "UG":
        return "Under Graduation";
        case "PG":
        return "Post Graduation";
        default:
        return "Post Graduation";
    }
};
// Helper function to normalize values for comparison
export const normalizeValue = (val: any) => {
    if (val === null || val === undefined || val === '') return '';
    return String(val).trim();
};
export const hasAddressData = (prefix = '', addressType = 'permanent', values: any) => {
    const owner = normalizeValue(values[`${prefix}${addressType}OwnershipStatus`]);
    const yearsInCurrentAddress = normalizeValue(values[`${prefix}${addressType}YearsInCurrentAddress`]);
    const YearsInCurrentCity = normalizeValue(values[`${prefix}${addressType}YearsInCurrentCity`]);
    const line1 = normalizeValue(values[`${prefix}${addressType}AddressLine1`]);
    const line2 = normalizeValue(values[`${prefix}${addressType}AddressLine2`]);
    const line3 = normalizeValue(values[`${prefix}${addressType}AddressLine3`]);
    const pincode = normalizeValue(values[`${prefix}${addressType}Pincode`]);
    const city = normalizeValue(values[`${prefix}${addressType}City`]);
    const state = normalizeValue(values[`${prefix}${addressType}State`]);
    const country = normalizeValue(values[`${prefix}${addressType}Country`]);

    return owner || yearsInCurrentAddress || YearsInCurrentCity || line1 || line2 || line3 || pincode || city || state || country;
};